import React, {useState, useEffect} from 'react';
import {Button, Chip, Grid, MenuItem, TextField, IconButton, InputAdornment} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import destinations from "../data/DestinationData";

const SearchBar = ({tours, handleSearch, resultsRef, selectedLocations, handleLocationChange}) => {
    const [isLabelShrunk, setIsLabelShrunk] = useState(false);
    const [filteredTours, setFilteredTours] = useState([]);

    useEffect(() => {
        if (tours && selectedLocations.length > 0) {
            const filtered = tours.filter(tour =>
                selectedLocations.every(location => tour.locations.includes(location))
            );
            setFilteredTours(filtered);
        } else {
            setFilteredTours([]);
        }
    }, [selectedLocations, tours]);

    const handleFocus = () => {
        setIsLabelShrunk(true);
    };

    const handleBlur = () => {
        if (selectedLocations.length === 0) {
            setIsLabelShrunk(false);
        }
    };

    const handleClear = () => {
        handleLocationChange({target: {value: []}});
    };

    return (
        <div className="searchBar" style={{justifyContent: 'center'}}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={10}>
                    <TextField
                        placeholder={'Select location'}
                        autoFocus={false}
                        style={{
                            margin: '0',
                            borderRadius: '10px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            height: '50px', // Keep the height of the search bar consistent
                            overflow: 'hidden', // Ensure height doesn't change when displaying selected locations
                            display: 'flex', // Use flex to center items
                            alignItems: 'center', // Center items vertically
                            justifyContent: 'center'
                        }}
                        select
                        label={isLabelShrunk ? '' : 'Select Locations'} // Show empty label when shrunk
                        value={selectedLocations}
                        onChange={handleLocationChange}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        SelectProps={{
                            multiple: true,
                            renderValue: (selected) => (
                                <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center'}}>
                                    {selected.map((value) => (
                                        <Chip key={value} label={value} style={{margin: '2px'}}/>
                                    ))}
                                </div>
                            ),
                            IconComponent: () => (
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <ArrowDropDownIcon/>
                                    {selectedLocations.length > 0 && (
                                        <IconButton
                                            size="small"
                                            onClick={handleClear}
                                            style={{marginLeft: -1}}
                                        >
                                            <ClearIcon style={{marginRight: '10px'}}/>
                                        </IconButton>
                                    )}
                                </div>
                            )
                        }}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{shrink: selectedLocations.length > 0 || isLabelShrunk}}
                    >
                        {destinations.map((destination) => (
                            <MenuItem key={destination.id} value={destination.name}>
                                {destination.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={2}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            handleSearch(filteredTours);
                            if (resultsRef.current) {
                                resultsRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
                            }
                        }}
                        style={{
                            marginTop: '0',
                            height: '50px', // Ensure button height matches search bar
                            borderRadius: '10px',
                            backgroundColor: '#27733d'
                        }}
                    >
                        Search
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};

export default SearchBar;
